<template>
  <div class="mt-2">
    <v-container style="margin-right: 0; margin-left: 0;" v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.DO) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))">
      <v-row style="height: 100%;" class="pl-4">
        <v-col md="6" class="pr-0">
          <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>Broadcast Message</h4>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-textarea label="Message" dense outlined hide-details v-model="message"></v-textarea>
            </v-card-text>
            <v-card-actions style="padding-bottom: 26px; padding-top: 26px;">
              <v-btn small color="success" style="position: absolute; right: 25px;" @click="sendMessage" :disabled="message === ''">Send</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { accessControlMixin } from '../components/mixins/index'

export default {
  mixins:[accessControlMixin],
  data () {
    return {
      message: ''
    }
  },
  mounted () {
    if (this.user.roles && (!this.user.roles.includes('*') && !this.userHasResourceAccess(this.RESOURCENAMES.DO) && !this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT))) {
      if (this.$route && this.$route.path !== '/') {
        this.$router.push('/')
      }
    }
  },
  computed: {
    ...mapGetters(['getUserLoggedIn']),
    user () {
      return this.getUserLoggedIn
    }
  },
  methods: {
    ...mapActions(['sendBroadcastMessage']),
    sendMessage () {
      this.sendBroadcastMessage({ message: this.message })
      this.message = ''
    }
  }
}
</script>
